export default "assets/images/icons/bike-916e5eb6.svg";